import { render, staticRenderFns } from "./create-report-patient.vue?vue&type=template&id=7167c1c5&scoped=true"
import script from "./create-report-patient.vue?vue&type=script&lang=js"
export * from "./create-report-patient.vue?vue&type=script&lang=js"
import style0 from "./create-report-patient.vue?vue&type=style&index=0&id=7167c1c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7167c1c5",
  null
  
)

export default component.exports